import { Country } from '@/domain/country/Country';
import { LIGHT_GREY, GREEN_SHADE_42, GREEN_SHADE_60 } from '@/primary/Color';
import { GeoJSON } from 'ol/format';

export interface CountryRendering {
  id: string;
  color: string;
  selectable: boolean;
}

export const toCountryRenderingFeature = (
  countryFeature: GeoJSON.Feature<GeoJSON.MultiPolygon, Country>
): GeoJSON.Feature<GeoJSON.MultiPolygon, CountryRendering> => {
  return {
    ...countryFeature,
    properties: {
      id: countryFeature.properties.id,
      color: LIGHT_GREY,
      selectable: false,
    },
  };
};

export const toCountryRendering = (country: Country, projectCountsByCountry: { [key: string]: number }): CountryRendering => {
  const counts = projectCountsByCountry[country.id];
  return {
    id: country.id,
    color: counts > 5 ? GREEN_SHADE_42 : counts > 0 ? GREEN_SHADE_60 : LIGHT_GREY,
    selectable: counts !== undefined && counts > 0,
  };
};
